// Use the full path to the file instead of the root path to work around eager loading issues
// eslint-disable-next-line import/no-extraneous-dependencies
import { setFederatedDomainsOnWindow } from '@trayio/shared-mfe/src/lib/utils/set-federated-domains-on-window';

setFederatedDomainsOnWindow();

import('./platformBootstrap');
